import React from 'react'
import PropTypes from 'prop-types'

import { StyledSurchargeTable, StyledHeading, StyledHourlyRates, StyledSmallText } from 'components/fuelSurcharge/styled';

const FuelSurchargeTable = ({ data }) => {

   const primaryData = data.primary;

   const borderColour = primaryData.table_border_colour;
   const headingColour = primaryData.heading_font_colour;
   const headingsBgColour = primaryData.fuel_surcharge_hourly_rate_heading_background_colour;
   const categoriesBgColour = primaryData.jet_category_cell_background_colour;

   const hourlyRatesBgColour = primaryData.hourly_rate_cell_bakcground_colour;
   const rateFontColour = primaryData.hourly_rate_font_colour;

   const fuelSurchargeHeading = primaryData.fuel_surcharge_heading;
   const categoryHeading = primaryData.jet_size_category_heading;
   const hourlyRateHeading = primaryData.hourly_rate_heading;
   
   const tableHeadingsDesktop = (
     <React.Fragment> 
       <tr className='desktop'>
         <StyledHeading bgColour={headingsBgColour} rowSpan='2'> { fuelSurchargeHeading } </StyledHeading>
         <StyledHeading bgColour={categoriesBgColour} colSpan="5"> { categoryHeading } </StyledHeading>
       </tr>
       <tr className='desktop'> 
         { data.items.map((item) => <StyledHeading key={item.jet_category} bgColour={categoriesBgColour}> {item.jet_category} </StyledHeading>) }   
       </tr>
     </React.Fragment>
   )

   const tableBodyDesktop = (
     <tr className='desktop'>
       <StyledHeading bgColour={headingsBgColour}> { hourlyRateHeading } </StyledHeading>
       { data.items.map((item) => {
            const hourlyRate = item.hourly_rate;
            
            return (
              <StyledHourlyRates 
                key={hourlyRate} 
                bgColour={hourlyRatesBgColour} 
                fontColour={rateFontColour}
              > 
                {hourlyRate} 
              </StyledHourlyRates>
            )
         })
       }
     </tr>
   )

   const tableHeadingsMobile = (
     <tr className='mobile'>
       <StyledHeading bgColour={headingsBgColour}> { categoryHeading } </StyledHeading>
       <StyledHeading bgColour={headingsBgColour}> { hourlyRateHeading } </StyledHeading>
     </tr>
   )

   const tableBodyMobile = (
      data.items.map((item) => {
         const jetSizeCat = item.jet_category;
   
         return (
           <tr key={jetSizeCat} className='mobile'>
             <StyledHeading bgColour={categoriesBgColour}> {jetSizeCat} </StyledHeading>
             <StyledHourlyRates bgColour={hourlyRatesBgColour} fontColour={rateFontColour}> {item.hourly_rate} </StyledHourlyRates>
           </tr>
         )
      })
   )
   
  return (
    <React.Fragment>
      <StyledSurchargeTable borderColour={borderColour} fontColour={headingColour}>
        <thead>
          { tableHeadingsDesktop }
          { tableHeadingsMobile }
        </thead>
        <tbody>
          { tableBodyDesktop }
          { tableBodyMobile }
        </tbody>
      </StyledSurchargeTable>

      <StyledSmallText> { primaryData.small_text_under_table } </StyledSmallText>

    </React.Fragment>
  )
}

FuelSurchargeTable.propTypes = {
  data: PropTypes.object,
}

export default FuelSurchargeTable
